import * as React from 'react';
import { Tag } from '@grandvisionhq/common';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';

const ProductTag = ({ className  })=>{
    const { activeVariant: { productTag  } ,  } = useProductData();
    if (!productTag || productTag.value === '') {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Tag, {
        className: className,
        iconKey: productTag.iconKey,
        label: productTag.value
    });
};

export { ProductTag };
//# sourceMappingURL=ProductTag.js.map
